import React from "react";
import { Phone, MapPin, Star } from "lucide-react";
import { RESTAURANT } from "../data/menu";
import { useReveal } from "../hooks/useReveal";

export default function Reservation() {
  const ref = useReveal();

  return (
    <section
      id="reservierung"
      data-testid="reservation-section"
      className="relative py-24 md:py-32 px-6 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-gold/20 blur-[140px]" />
      </div>

      <div className="max-w-4xl mx-auto relative reveal" ref={ref}>
        <div className="text-center mb-10">
          <p className="text-gold tracking-[0.4em] text-xs uppercase mb-4">Tisch sichern</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white">
            <span className="italic text-gradient-gold">Reservierung</span>
          </h2>
          <div className="gold-divider w-24 mx-auto mt-6" />
        </div>

        {/* Rating badge */}
        <div
          data-testid="rating-badge"
          className="flex flex-col items-center mb-8"
        >
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full glass-panel border-gold/40">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map((i) => (
                <Star
                  key={i}
                  className={`w-4 h-4 ${i === 5 ? "text-gold/70" : "text-gold"}`}
                  fill="currentColor"
                  strokeWidth={0}
                />
              ))}
            </div>
            <span className="font-serif text-xl text-gold font-semibold leading-none">4,9</span>
            <span className="text-white/85 text-sm">
              · über 200 zufriedene Gäste
            </span>
          </div>
        </div>

        <div className="glass-panel rounded-3xl p-8 md:p-14 text-center">
          <p className="text-white/85 text-lg md:text-xl leading-relaxed mb-3 max-w-2xl mx-auto">
            Reservierungen nehmen wir ausschließlich telefonisch entgegen.
          </p>
          <p className="text-white/55 mb-10">
            Rufen Sie uns an – wir freuen uns auf Ihren Besuch im Poseidon.
          </p>

          <a
            href={`tel:${RESTAURANT.phoneTel}`}
            data-testid="main-call-button"
            className="group inline-flex items-center gap-4 px-8 md:px-12 py-5 md:py-6 rounded-full bg-gold text-black font-semibold text-lg md:text-xl tracking-wide hover:bg-gold-soft transition-all duration-300 hover:scale-[1.04] shadow-2xl shadow-gold/40"
          >
            <span className="flex items-center justify-center w-12 h-12 rounded-full bg-black text-gold group-hover:rotate-12 transition-transform">
              <Phone className="w-6 h-6" />
            </span>
            Jetzt anrufen
          </a>

          <a
            href={`tel:${RESTAURANT.phoneTel}`}
            data-testid="phone-display"
            className="block mt-8 font-serif text-3xl md:text-5xl text-gradient-gold tracking-wide hover:opacity-80 transition-opacity"
          >
            {RESTAURANT.phone}
          </a>

          <div className="mt-12 grid sm:grid-cols-2 gap-6 text-left">
            <div className="flex items-start gap-4 p-5 rounded-xl bg-white/5 border border-white/10">
              <MapPin className="text-gold flex-shrink-0 mt-1" />
              <div>
                <p className="text-xs uppercase tracking-widest text-gold/70 mb-1">Adresse</p>
                <p className="text-white">{RESTAURANT.address}</p>
              </div>
            </div>
            <div className="flex items-start gap-4 p-5 rounded-xl bg-white/5 border border-white/10">
              <Phone className="text-gold flex-shrink-0 mt-1" />
              <div>
                <p className="text-xs uppercase tracking-widest text-gold/70 mb-1">Telefon</p>
                <p className="text-white">{RESTAURANT.phone}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
